import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { TerminkennzeichenService } from '../../api';

export const getTerminkennzeichen =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    new TerminkennzeichenService().getTerminkennzeichen().then(result => {
      dispatch({
        type: ActionTypes.GET_TERMINKENNZEICHEN,
        payload: result.data,
      });
    });
  };
